module.exports = __webpack_public_path__ + "img/stars_full.b86dcde0.png";